import {
  ACCOUNT,
  FLOOR
} from '../../reduxs'

const initialState = {
  listFloor: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FLOOR.actionType.SAVE_LIST_FLOOR:
      return {
        ...state, listFloor: action.list
      }
    case FLOOR.actionType.CLEAR_LIST_FLOOR:
      return {
        ...state, listFloor: initialState.listFloor
      }
    case ACCOUNT.actionType.CLEAR_ALL_DATA:
      return {
        ...initialState
      }

    default:
      return state
  }
}
